
import { FilterCategory, FilterOption } from './types';

// Define target cities with coordinates for device placement
export const targetCities = [
  // Northeast
  { name: 'New York', lat: 40.7128, lng: -74.0060 },
  { name: 'Boston', lat: 42.3601, lng: -71.0589 },
  { name: 'Philadelphia', lat: 39.9526, lng: -75.1652 },
  
  // Midwest
  { name: 'Chicago', lat: 41.8781, lng: -87.6298 },
  { name: 'Detroit', lat: 42.3314, lng: -83.0458 },
  { name: 'Minneapolis', lat: 44.9778, lng: -93.2650 },
  
  // South
  { name: 'Atlanta', lat: 33.7490, lng: -84.3880 },
  { name: 'Miami', lat: 25.7617, lng: -80.1918 },
  { name: 'Dallas', lat: 32.7767, lng: -96.7970 },
  { name: 'Houston', lat: 29.7604, lng: -95.3698 },
  
  // West
  { name: 'Los Angeles', lat: 34.0522, lng: -118.2437 },
  { name: 'San Francisco', lat: 37.7749, lng: -122.4194 },
  { name: 'Seattle', lat: 47.6062, lng: -122.3321 },
  { name: 'Denver', lat: 39.7392, lng: -104.9903 },
  
  // Central
  { name: 'St. Louis', lat: 38.6270, lng: -90.1994 },
  { name: 'Kansas City', lat: 39.0997, lng: -94.5786 },
  { name: 'Indianapolis', lat: 39.7684, lng: -86.1581 },
  { name: 'Columbus', lat: 39.9612, lng: -82.9988 },
  
  // Additional cities
  { name: 'Phoenix', lat: 33.4484, lng: -112.0740 },
  { name: 'San Antonio', lat: 29.4241, lng: -98.4936 },
  { name: 'San Diego', lat: 32.7157, lng: -117.1611 },
  { name: 'Fort Worth', lat: 32.7555, lng: -97.3308 },
  { name: 'Charlotte', lat: 35.2271, lng: -80.8431 },
  { name: 'Austin', lat: 30.2672, lng: -97.7431 },
  { name: 'Jacksonville', lat: 30.3322, lng: -81.6557 },
  { name: 'Washington', lat: 38.9072, lng: -77.0369 },
  { name: 'Baltimore', lat: 39.2904, lng: -76.6122 },
  { name: 'Nashville', lat: 36.1627, lng: -86.7816 },
  { name: 'Portland', lat: 45.5051, lng: -122.6750 },
  { name: 'Las Vegas', lat: 36.1699, lng: -115.1398 }
];

// City utility functions
export const getCityByDepartmentAndIndex = (department: string, index: number): { name: string; lat: number; lng: number } => {
  const departmentCities: Record<string, { name: string; lat: number; lng: number }[]> = {
    'North': targetCities.slice(0, 4),
    'South': targetCities.slice(6, 10),
    'East': targetCities.slice(0, 3).concat(targetCities.slice(25, 27)),
    'West': targetCities.slice(10, 14),
    'Central': targetCities.slice(14, 18)
  };
  
  const cities = departmentCities[department] || departmentCities['Central'];
  return cities[index % cities.length];
};

export const getCityByIndex = (index: number): { name: string; lat: number; lng: number } => {
  return targetCities[index % targetCities.length];
};

// Filter processing functions
export const createFilterCategories = (deviceType: string = 'energy'): FilterCategory[] => {
  return [
    {
      name: 'status',
      options: [
        { value: 'Healthy', label: 'Healthy' },
        { value: 'Warning', label: 'Warning' },
        { value: 'Critical', label: 'Critical' },
        { value: 'Inactive', label: 'Inactive' },
        { value: 'Offline', label: 'Offline' }
      ]
    },
    {
      name: 'type',
      options: [
        { value: 'smartMeter', label: 'Smart Meter' },
        { value: 'gateway', label: 'Gateway' },
        { value: 'voltageRegulator', label: 'Voltage Regulator' }
      ]
    },
    {
      name: 'department',
      options: [
        { value: 'North', label: 'North' },
        { value: 'South', label: 'South' },
        { value: 'East', label: 'East' },
        { value: 'West', label: 'West' },
        { value: 'Central', label: 'Central' }
      ]
    }
  ];
};

export const processActiveFilters = (activeFilters: Record<string, string[]>): string[] => {
  // Convert the activeFilters object to a flat array of filter values
  return Object.values(activeFilters).flatMap(values => values);
};

export const filterDevicesByCategories = <T extends { status: string; type: string; department?: string }>(
  devices: T[],
  activeFilters: Record<string, string[]>
): T[] => {
  // If no filters are active, return all devices
  if (Object.keys(activeFilters).length === 0) {
    return devices;
  }

  return devices.filter(device => {
    // Check if the device matches all active filters
    return Object.entries(activeFilters).every(([category, values]) => {
      // If no values are selected for this category, don't filter by it
      if (values.length === 0) return true;
      
      // For each category, check if the device has a matching value
      switch (category) {
        case 'status':
          return values.includes(device.status);
        case 'type':
          return values.includes(device.type);
        case 'department':
          return device.department ? values.includes(device.department) : false;
        default:
          return true;
      }
    });
  });
};
